// extracted by mini-css-extract-plugin
module.exports = {"header":"P_R","sectionHeader":"P_bb","sectionDark":"P_bl","imageContainer":"P_bj","imageSquare":"P_b4","image":"P_8","logo":"P_b5"};